import React, { useEffect } from 'react'
import CalculatorContainer from '../containers/Calculator'
import Nav from '../components/nav/Nav';

const Calculator: React.FC= () => {


  useEffect(() => {
    document.title = 'Elite Community CU | Calculator';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Savings Calculators What will my savings be worth? How long will it take for my savings goals to be met? What will it take ...";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <CalculatorContainer />
    </div>
  )
}

export default Calculator